import get from 'lodash/get';
import { CLEARORGANISATION, SETSHORTCODE } from '../types';
import { LOGOUT, SET_USER_DATA } from '../../app/login/duck/types';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGOUT:
    case CLEARORGANISATION:
      return {};
    case SETSHORTCODE:
      return {
        ...state,
        ShortCode: action.ShortCode,
      };
    case SET_USER_DATA: {
      const userOrgs = get(action, 'user.organisations', []);
      const fallback = get(action, 'user.organisations.0.ShortCode');
      const lastAccessed = get(action, 'user.latestAccess.organisation', fallback);
      const { isAdmin } = action.user;
      const ShortCode =
        isAdmin || userOrgs.find(o => o.ShortCode === lastAccessed) ? lastAccessed : fallback;

      return {
        ...state,
        ShortCode,
      };
    }
    default:
      return state;
  }
};
